import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  ApiError,
  fetchNotifications,
  markAllNotificationsRead,
  markNotificationRead,
  type NotificationCategory,
  type NotificationListResponse,
} from '../lib/api'
import { hasTokens } from '../lib/auth'

export function useNotifications(
  unread_only: boolean = false,
  limit: number = 20,
  category: NotificationCategory = 'all',
) {
  return useQuery<NotificationListResponse, ApiError>({
    queryKey: ['notifications', unread_only, limit, category],
    queryFn: () => fetchNotifications(unread_only, limit, category),
    enabled: hasTokens(),
    staleTime: 10_000,
    refetchInterval: 30_000,
    retry: false,
  })
}

export function useMarkRead() {
  const qc = useQueryClient()
  return useMutation<void, ApiError, string>({
    mutationFn: (id) => markNotificationRead(id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['notifications'] })
    },
  })
}

export function useMarkAllRead(category: NotificationCategory = 'all') {
  const qc = useQueryClient()
  return useMutation<{ updated: number }, ApiError, void>({
    mutationFn: () => markAllNotificationsRead(category),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['notifications'] })
    },
  })
}
